import { IAdminManagementState } from './adminManagement.types'
import {
  FETCH_ADMINS_REQUEST,
  FETCH_ADMINS_SUCCESS,
  FETCH_ADMINS_FAILURE,
  TOGGLE_ADMIN_SUSPEND_REQUEST,
  TOGGLE_ADMIN_SUSPEND_SUCCESS,
  TOGGLE_ADMIN_SUSPEND_FAILURE,
  RESET_ADMIN_FORM_ACTION
} from './adminManagement.actionTypes'

const initialState: IAdminManagementState = {
  admins: [],
  loading: false,
  error: null,
  addAdmin: {
    resetForm: false
  }
}

export const adminManagementReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_ADMINS_REQUEST:
    case TOGGLE_ADMIN_SUSPEND_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case FETCH_ADMINS_SUCCESS:
      return {
        ...state,
        loading: false,
        admins: action.payload
      }

    case TOGGLE_ADMIN_SUSPEND_SUCCESS:
      return {
        ...state,
        loading: false,
        admins: state.admins.map((admin) =>
          admin.id === action.payload.id ? action.payload : admin
        )
      }

    case FETCH_ADMINS_FAILURE:
    case TOGGLE_ADMIN_SUSPEND_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case RESET_ADMIN_FORM_ACTION:
      return {
        ...state,
        addAdmin: action.payload
      }

    default:
      return state
  }
}
